/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteOAuthExtensionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {DeleteOAuthExtensionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const deleteExtensionOauth = (request:DeleteOAuthExtensionRequest, options?: CashRequestOptions) => post<DeleteOAuthExtensionRequest, DeleteOAuthExtensionResponse>("/2.0/cash/delete-extension-oauth", request, {...options, rejectOnError: true })